import FlatPickr from 'vue-flatpickr-component'

export default {
    components: {FlatPickr},
    data() {
        return {
            flatPickr: {
                locale: document.documentElement.lang.slice(0, 2),
                wrap: true,
                weekNumbers: true,
                altInput: true,
                altFormat: 'j F Y',
                altInputClass: 'form-select',
                dateFormat: 'Y-m-d',
            },
        }
    }
}
